module.exports = __webpack_public_path__ + "static/media/CIBERSEGURIDAD_CBS-G4SPREM_01.727c5ca1.xlsx";